import { useEffect, useRef, useState } from "react";
import AppShell from "@/components/AppShell";
import { PlayCircle, Clock } from "@phosphor-icons/react";

const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, "0")}`;

export default function Training() {
  const [videos, setVideos] = useState(null);
  useEffect(() => {
    fetch("/training/manifest.json").then(r => r.json()).then(setVideos).catch(() => setVideos(false));
  }, []);
  return <AppShell>
    <div className="mb-6">
      <div className="eyebrow text-accent">Learn HaulGuard</div>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Training</h1>
      <p className="text-muted-foreground mt-1 max-w-xl">Short walkthroughs recorded in the app. Captions are on, so you can watch with the sound off.</p>
    </div>
    <div className="grid md:grid-cols-2 gap-6">
      {videos === null && <div className="col-span-full border-2 border-dashed p-10 text-center text-muted-foreground" data-testid="training-empty">Training videos are loading…</div>}
      {videos === false && <div className="col-span-full border-2 border-dashed p-10 text-center text-muted-foreground" data-testid="training-error">Couldn't load the training videos. Check your connection and refresh.</div>}
      {(videos || []).map((v, i) => <VideoCard key={v.id} v={v} n={i + 1}/>)}
    </div>
  </AppShell>;
}

function VideoCard({ v, n }) {
  const ref = useRef(null);
  const [t, setT] = useState(0);
  const seek = (s) => { if (!ref.current) return; ref.current.currentTime = s + 0.05; setT(s + 0.05); ref.current.play().catch(() => {}); };
  const active = v.chapters.reduce((a, c, i) => (t >= c.start ? i : a), 0);
  return <section className="bg-white border border-border/60 p-4 md:p-5" data-testid={`training-video-${v.id}`}>
    <div className="flex items-center justify-between mb-3">
      <div>
        <div className="eyebrow text-accent">Video {n}</div>
        <h2 className="font-display font-bold text-xl">{v.title}</h2>
      </div>
      <span className="text-xs text-muted-foreground font-mono-tech flex items-center gap-1"><Clock size={14}/> {fmt(v.duration)}</span>
    </div>
    <div className="bg-primary flex justify-center">
      <video ref={ref} controls playsInline preload="metadata" poster={v.poster} onTimeUpdate={(e) => setT(e.target.currentTime)}
             className="w-full max-w-[360px] aspect-[9/16] bg-primary" data-testid={`training-player-${v.id}`}>
        <source src={v.src} type="video/mp4"/>
        <track kind="captions" src={v.captions} srcLang="en" label="English" default/>
      </video>
    </div>
    <ol className="mt-4 space-y-1">
      {v.chapters.map((c, i) => (
        <li key={i}>
          <button onClick={() => seek(c.start)} data-testid={`chapter-${v.id}-${i}`}
            className={`w-full flex items-center gap-3 px-3 py-3 text-left text-sm border-l-4 transition-colors ${i === active && t > 0 ? "border-accent bg-accent/10 font-bold" : "border-transparent hover:bg-secondary"}`}>
            <PlayCircle size={18} className="text-primary shrink-0"/>
            <span className="flex-1">{c.title}</span>
            <span className="font-mono-tech text-xs text-muted-foreground">{fmt(c.start)}</span>
          </button>
        </li>
      ))}
    </ol>
  </section>;
}
